import types from "./types";

const initialState = {
  subscriptionPlan: {},
  getTestimonalData: {},
};

const subscription = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SUBSCRIPTION_RESP:
      return {
        ...state,
        subscriptionPlan: action.payload,
      };
    case types.GET_SUBSCRIPTION_CLEAR:
      return {
        ...state,
        subscriptionPlan: {},
      };
    case types.GET_TESTIMONAL_RESP:
      return {
        ...state,
        getTestimonalData: action.payload,
      };
    case types.GET_TESTIMONAL_CLEAR:
      return {
        ...state,
        getTestimonalData: {},
      };
    default:
      return state;
  }
};

export default subscription;
